import { BLUR_EDIT_NOTE } from 'constants/action_types'

export default function doCancelEditNote() {
  return {
    type: BLUR_EDIT_NOTE,
  }
}
